import { useDispatch } from 'react-redux';
import { setCurrentUser } from './actions/users/loginUser';
import { setAppMode } from './actions/app/app';
import useAppMode from './hooks/useAppMode';
import Loading from './components/Loading/Loading';

const AppModeInitializer = ({ children }) => {
  const [authDataResponse, visitorType, isLoading] = useAppMode();
  const dispatch = useDispatch();
  authDataResponse && dispatch(setCurrentUser(authDataResponse));
  visitorType && dispatch(setAppMode(visitorType));

  if (isLoading) return <Loading />;

  return children;
};

export default AppModeInitializer;
